import { Injectable } from '@angular/core';
import { JwtHelper } from 'angular2-jwt';
@Injectable()
export class AuthService {

  public currentPath = '';

  constructor(public jwtHelper: JwtHelper) {

  }

  public isAuthenticated(): number {
    const token = localStorage.getItem('userToken');
    if (token === null) {
      return 0;
    } else {
      const tokenExpired = this.jwtHelper.isTokenExpired(token);
      if (tokenExpired) {
        return 2;
      }
      return 1;
    }
  }
}
